<template>
	<component :is="view" ref="childComponent" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore } from '../store';
import { useRouter } from 'vue-router';
import BeschwerdeNeu from './BeschwerdeNeu.vue';
import BeschwerdeNeuPublic from './BeschwerdeNeuPublic.vue';

export default defineComponent({
	name: 'BeschwerdenWrapper',
	components: {
		BeschwerdeNeu,
		BeschwerdeNeuPublic,
	},
	setup() {
		const store = useStore();
		const router = useRouter();
		const loggedin = computed(() => store.state.loggedin);

		const view = computed(() => {
			if (loggedin.value) {
				return BeschwerdeNeu;
			} else {
				router.push({ name: 'Formular', replace: true });
			}
		});

		return {
			view,
		};
	},
	beforeRouteLeave(to, from, next) {
		const childComponent = this.$refs.childComponent;

		if (childComponent && typeof childComponent.handleBeforeRouteLeave === 'function') {
			childComponent.handleBeforeRouteLeave(to, from, next);
		} else {
			next();
		}
	},
});
</script>
